import { isDefaultLanguage } from "./isDefaultLanguage";
import { getDefaultFolder } from "./getDefaultFolder";

export { isDefaultLanguage, getDefaultFolder };
